export default {
  namespaced: true,
  state: {
    selected_menu: 0,
    list: [
      { title: "Métricas", /*icon: require('../../assets/img/users.png'),*/ link: "/admin/metrics" },
      { title: "Usuarios", /*icon: require('../../assets/img/users.png'),*/ link: "/admin/users" },
      { title: "Profesionales", /*icon: require('../../assets/img/users.png'),*/ link: "/admin/professionals" },
      { title: "Descuentos", /*icon: require('../../assets/img/users.png'),*/ link: "/admin/discounts" },
      { title: "Especialidades", /*icon: require('../../assets/img/posts.png'),*/ link: "/admin/specialities" },
      { title: "Motivo de consulta", /*icon: require('../../assets/img/tags.png'),*/ link: "/admin/tags" },
      { title: "Time Ranges", /*icon: require('../../assets/img/tags.png'),*/ link: "/admin/time_range" },
      { title: "Países", /*icon: require('../../assets/img/terms.png'),*/ link: "/admin/countries" },
      { title: "Solicitudes de Trabajo", /*icon: require('../../assets/img/terms.png'),*/ link: "/admin/work_requests" },
      { title: "Solicitudes Empresariales", /*icon: require('../../assets/img/terms.png'),*/ link: "/admin/enterprise_requests" },
      { title: "FAQ's", /*icon: require('../../assets/img/terms.png'),*/ link: "/admin/faqs" },
      { title: "Política de Privacidad", /*icon: require('../../assets/img/policy.png'),*/ link: "/admin/privacy" },
      { title: "Términos y condiciones", /*icon: require('../../assets/img/terms.png'),*/ link: "/admin/terms" }

    ]
  },
  mutations: {
    set_selected_menu(state, selected) {
      state.selected_menu = selected;
    }
  },
  actions: {
    selected_menu({ commit }, selected) {
      commit("set_selected_menu", selected);
    }
  },
  getters: {},
  setters: {},
  modules: {}
};
